/**
 * AuthLoginReq 类型和 Schema 定义
 *
 * ⚠️ 注意: 此文件由脚本自动生成，请勿手动修改
 * 如需更新，请运行代码生成脚本
 */
import type { SchemaDefinition } from './_schema'

/**
 * AuthLoginReq
 */
export interface AuthLoginReq {
  /** 登录方式 */
  login_method?: string
  /** 用户名 */
  username: string
  /** 密码（密码登录时必填） */
  password?: any
  /** 验证码:（验证码登录时必填） */
  captcha?: string
  /** User-Agent信息 */
  user_agent?: string
  /** 浏览器信息 */
  browser?: string
  /** 登录IP地址 */
  login_ip?: string
}

/**
 * AuthLoginReq Schema
 */
export const AuthLoginReqSchema: SchemaDefinition = {
  properties: {
    login_method: {
      description: '登录方式',
      format: 'cons.StaffLoginMethod',
      type: 'string',
      label: '登录方式',
    },
    username: {
      description: '用户名',
      format: 'string',
      minLength: 2,
      type: 'string',
      label: '用户名',
    },
    password: {
      description: '密码（密码登录时必填）',
      format: 'string',
      type: 'password',
      label: '密码',
    },
    captcha: {
      description: '验证码:（验证码登录时必填）',
      format: 'string',
      maxLength: 6,
      minLength: 6,
      type: 'string',
      label: '验证码',
    },
    user_agent: {
      description: 'User-Agent信息',
      format: 'string',
      type: 'string',
      label: 'User-Agent信息',
    },
    browser: {
      description: '浏览器信息',
      format: 'string',
      type: 'string',
      label: '浏览器信息',
    },
    login_ip: {
      description: '登录IP地址',
      format: 'string',
      type: 'string',
      label: '登录IP地址',
    },
  },
  required: ['username'],
  type: 'object',
}
